import { render, staticRenderFns } from "./modal-view.vue?vue&type=template&id=48d62213"
import script from "./modal-view.vue?vue&type=script&lang=ts"
export * from "./modal-view.vue?vue&type=script&lang=ts"
import style0 from "./modal-view.vue?vue&type=style&index=0&id=48d62213&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports